import ListaNominal from "./ListaNominal";
export default ListaNominal;
